import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import permissions from '../../../../constants/permissions';
import ModalManager from '../../../../components/modal/ModalManager';
import {NotificationManager} from '../../../../components/common/react-notifications';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {filter, includes, join, map, omit, pull} from 'lodash';
import Rbac from '../../../../components/Rbac';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rbac: null,
      loading: true,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/rbac');
      this.setState({
        rbac: data,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteRole = async role => {
    const {t} = this.props;
    const {rbac} = this.state;
    const newRoles = pull(rbac.roles, role);
    const newGrants = omit(rbac.grants, [role]);
    const newRbac = {
      ...rbac,
      roles: [...newRoles],
      grants: {...newGrants},
    };
    try {
      await Api.invoke('PUT', '/admin-ui/rbac', {
        rbac: JSON.stringify(newRbac),
      });
      NotificationManager.success(t('Role deleted successfully'), t('Message'));
      this.setState({
        rbac: newRbac,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/settings/roles/create');
  };

  onPressDelete = role => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this role ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteRole(role);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Title'),
      accessor: 'role',
      maxWidth: 200,
    },
    {
      Header: t('Permissions'),
      accessor: 'permissions',
      Cell: props => {
        const options = [...this.state.rbac.roles.map(role => ({label: role, value: role})), ...permissions];
        if (props.value) {
          const access = filter(options, obj => includes(props.value, obj.value));
          return <span>{join(map(access, 'label'), ', ')}</span>;
        }
        return null;
      }
    },
    {
      Header: t('Actions'),
      width: 100,
      Cell: props => <div>
        <i
          className="simple-icon-trash delete-icon mx-3 cursor-pointer"
          onClick={() => {this.onPressDelete(props.original.role);}}
        />
        <Link to={{
          pathname: '/dashboard/settings/roles/update',
          state: {
            role: props.original.role,
          },
        }}
        >
          <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
        </Link>
      </div>,
      show: Rbac.hasPermission('update_rbac'),
    },
  ];

  render() {
    const {t} = this.props;
    const {rbac} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Roles List')}
                  <Rbac permission='update_rbac'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  data={rbac && rbac.roles ? rbac.roles.map(role => ({role, permissions: rbac.grants[role]})) : []}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns(t)}
                  pageSize={rbac && rbac.roles ? rbac.roles.length : 5}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
